import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './ItemMinifiedHeader.module.scss';
import { CurrencyCode } from '../../constants/currencyConstants';
import CloseButton from '../closeButton/CloseButton';
import { getCurrencySymbol, getFormattedPrice } from '../helper/common';

interface IItemMinifiedHeaderProps {
	name: string;
	imageUrl?: string;
	price?: number;
	description?: string;
	storeId: string;
	id: string;
	imgDisplay: string;
	isPageScrolled: boolean;
	currency: CurrencyCode;
}

const ItemMinifiedHeader: React.FC<IItemMinifiedHeaderProps> = ({
	name,
	imageUrl,
	price,
	description,
	storeId,
	id,
	imgDisplay,
	isPageScrolled,
	currency,
}: IItemMinifiedHeaderProps) => {
	const navigate = useNavigate();
	const tableRefId = localStorage.getItem('tableRef');

	const handleCloseClick = () => {
		localStorage.removeItem('itemDetails');
		navigate(`/${storeId}?tableRef=${tableRefId}`);
	};

	return (
		<div
			id={id}
			className={
				imgDisplay === 'image' ? styles.itemMinifiedHeaderMainBlock : styles.itemMinifiedHeaderMainBlockNoImage
			}
			style={isPageScrolled ? { visibility: 'visible' } : { visibility: 'hidden' }}
		>
			<div className={isPageScrolled ? styles.itemMiniHeader : styles.itemMiniHeaderHidden}>
				{imageUrl && (
					<div className={styles.itemImageBlock}>
						<img src={imageUrl} className={styles.itemImage} alt={name} />
					</div>
				)}
				<div
					className={
						imageUrl && description
							? styles.itemInformationBlock
							: description?.length !== undefined
							? styles.itemInformationBlockWithoutImageWithDescription
							: styles.itemInformationBlockWithoutImage
					}
				>
					<div className={styles.itemTitle}>{name}</div>
					<div className={styles.itemDescription}>{description}</div>
					{price ? (
						<div className={styles.itemPrice}>{getFormattedPrice(price, currency)}</div>
					) : (
						<div className={styles.itemPrice}>{`${getCurrencySymbol(currency)}0.00`}</div>
					)}
				</div>
				<CloseButton withImage={false} onClick={handleCloseClick} />
			</div>
		</div>
	);
};

export default ItemMinifiedHeader;
